import { DOWNLOAD_CACHE_KEY, fetchDownloads } from './helpers';
export const fetcher = async (client, item, uuid) => {
    const downloads = await fetchDownloads(DOWNLOAD_CACHE_KEY, uuid);
    client.setQueryData([DOWNLOAD_CACHE_KEY], downloads);
    downloads.forEach((item) => {
        client.setQueryData([DOWNLOAD_CACHE_KEY, { id: item.id }], item);
    });
    if (item) {
        const match = downloads.find(({ id }) => item.id === id);
        return match || false;
    }
    return downloads;
};
//# sourceMappingURL=fetcher.js.map